var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-layout",
    {
      staticClass: "home-container",
      attrs: { id: "components-layout-demo-custom-trigger" },
    },
    [
      _c("div", { staticClass: "box_banner" }, [
        _c("img", {
          staticStyle: { display: "block", width: "100%" },
          attrs: { src: _vm.banner },
        }),
        _c(
          "div",
          {
            staticClass: "box_banner_logo",
            on: {
              click: function ($event) {
                return _vm.gohome()
              },
            },
          },
          [
            _c("img", {
              staticStyle: {
                width: "68px",
                height: "78px",
                "margin-right": "22px",
              },
              attrs: { src: _vm.httplogo },
            }),
            _c("div", { style: { fontSize: _vm.fontSize + "px" } }, [
              _vm._v(_vm._s(_vm.configdata.projectname)),
            ]),
          ]
        ),
      ]),
      _c("div", { staticClass: "box_content" }, [
        _c(
          "div",
          {
            staticClass: "box_content_list",
            on: {
              click: function ($event) {
                return _vm.titleClick(1, 0)
              },
            },
          },
          [
            _c("img", {
              staticClass: "box_content_list_img",
              attrs: { src: _vm.menuimg1 },
            }),
            _c("div", { staticClass: "box_content_list_text" }, [
              _vm._v("证书新购"),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "box_content_list",
            on: {
              click: function ($event) {
                return _vm.titleClick(2, 0)
              },
            },
          },
          [
            _c("img", {
              staticClass: "box_content_list_img",
              attrs: { src: _vm.menuimg2 },
            }),
            _c("div", { staticClass: "box_content_list_text" }, [
              _vm._v("制图服务"),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "box_content_list",
            on: {
              click: function ($event) {
                return _vm.titleClick(8, 0)
              },
            },
          },
          [
            _c("img", {
              staticClass: "box_content_list_img",
              attrs: { src: _vm.menuimg3 },
            }),
            _c("div", { staticClass: "box_content_list_text" }, [
              _vm._v("延期服务"),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "box_content_list",
            on: {
              click: function ($event) {
                return _vm.titleClick(6, 0)
              },
            },
          },
          [
            _c("img", {
              staticClass: "box_content_list_img",
              attrs: { src: _vm.menuimg4 },
            }),
            _c("div", { staticClass: "box_content_list_text" }, [
              _vm._v("证书检测"),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "box_content_list",
            on: {
              click: function ($event) {
                return _vm.titleClick(3, 0)
              },
            },
          },
          [
            _c("img", {
              staticClass: "box_content_list_img",
              attrs: { src: _vm.menuimg5 },
            }),
            _c("div", { staticClass: "box_content_list_text" }, [
              _vm._v("用户中心"),
            ]),
          ]
        ),
      ]),
      _c("div", { staticClass: "box_contactus" }, [
        _c("img", {
          staticStyle: { display: "block", width: "217px", height: "366px" },
          attrs: { src: _vm.contactu },
        }),
        _c("div", { staticClass: "box_contactus_content" }, [
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "18px",
                "font-weight": "bold",
                "margin-top": "15px",
              },
            },
            [_vm._v("联系我们")]
          ),
          _c("div", { staticStyle: { color: "#2882FD" } }, [
            _vm._v("Contact Us"),
          ]),
          _c("div", { staticStyle: { "margin-top": "20px" } }, [
            _vm._v("企业客服"),
          ]),
          _c("div", [_vm._v(_vm._s(_vm.configdata.servicephone) + " ")]),
          _c("div", { staticStyle: { "margin-top": "20px" } }, [
            _vm._v("客服邮箱"),
          ]),
          _c("div", [_vm._v(_vm._s(_vm.configdata.maile))]),
        ]),
      ]),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }